import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AdminProtectedRoute } from "@/components/AdminProtectedRoute";
import Index from "./pages/Index";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Checkout from "./pages/Checkout";
import NotFound from "./pages/NotFound";
import DashboardLayout from "./components/dashboard/DashboardLayout";
import Dashboard from "./pages/Dashboard";
import DashboardNumbers from "./pages/DashboardNumbers";
import NumberAdd from "./pages/NumberAdd";
import NumberEdit from "./pages/NumberEdit";
import DashboardBilling from "./pages/DashboardBilling";
import DashboardUpgrade from "./pages/DashboardUpgrade";
import DashboardProfiles from "./pages/DashboardProfiles";
import DashboardSettings from "./pages/DashboardSettings";
import DashboardContacts from "./pages/DashboardContacts";
import DashboardGroups from "./pages/DashboardGroups";
import Onboarding from "./pages/Onboarding";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import ManagerLogin from "./pages/manager/ManagerLogin";
import ManagerLayout from "./components/manager/ManagerLayout";
import ManagerDashboard from "./pages/manager/ManagerDashboard";
import ManagerAccounts from "./pages/manager/ManagerAccounts";
import ManagerAccountDetail from "./pages/manager/ManagerAccountDetail";
import ManagerBilling from "./pages/manager/ManagerBilling";
import ManagerSettings from "./pages/manager/ManagerSettings";
import ManagerAdmins from "./pages/manager/ManagerAdmins";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-use" element={<TermsOfUse />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
            <Route path="/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="numbers" element={<DashboardNumbers />} />
              <Route path="numbers/add" element={<NumberAdd />} />
              <Route path="numbers/:id/edit" element={<NumberEdit />} />
              <Route path="billing" element={<DashboardBilling />} />
              <Route path="profiles" element={<DashboardProfiles />} />
              <Route path="contacts" element={<DashboardContacts />} />
              <Route path="groups" element={<DashboardGroups />} />
              <Route path="upgrade" element={<DashboardUpgrade />} />
              <Route path="settings" element={<DashboardSettings />} />
            </Route>
            {/* Manager (Admin) */}
            <Route path="/manager/login" element={<ManagerLogin />} />
            <Route path="/manager" element={<AdminProtectedRoute><ManagerLayout /></AdminProtectedRoute>}>
              <Route index element={<ManagerDashboard />} />
              <Route path="accounts" element={<ManagerAccounts />} />
              <Route path="accounts/:id" element={<ManagerAccountDetail />} />
              <Route path="admins" element={<ManagerAdmins />} />
              <Route path="billing" element={<ManagerBilling />} />
              <Route path="settings" element={<ManagerSettings />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
